import Arrow from "@assets/icons/arrow-right.svg";
import { Block } from "@components/block";
import { Button } from "@components/button";
import { RequestModal } from "@components/request-modal";
import { Table } from "@components/table";
import { useAppeals } from "@features/appeals";
import { useNavigateWithUserId } from "@hooks/use-navigate";
import { useCallback, useEffect, useState } from "react";
import styles from "./disputes.module.scss";
import { MergedAppeal } from "@features/appeals/slice";
import { traderAppelConfig } from "../../../../../pages/trader/disputes";
import { useWebSocket } from "@request/useWebsocket";
import { WebsocketUpdateType } from "@request/websocket";

export const Disputes = () => {
  const navigate = useNavigateWithUserId();

  const { state, getAppeals } = useAppeals();
  const { lastMessage } = useWebSocket();

  useEffect(() => {
    if (lastMessage && lastMessage.type == WebsocketUpdateType.Appeal) {
      getAppeals({ page: 1, limit: 10, status: "processing" });
    }
  }, [lastMessage]);

  useEffect(() => {
    getAppeals({ limit: 10, page: 1, status: "processing" });
  }, [getAppeals]);

  const appeals = state.appeals?.slice(0, 3);

  const [selectedAppeal, setSelectedAppeal] = useState<MergedAppeal>();

  const hideModal = useCallback(() => {
    setSelectedAppeal(undefined);
  }, []);

  return (
    <>
      <Block className={styles.disputes}>
        <div className={styles.header}>
          <h3>Открытые споры</h3>
          <Button
            icon={Arrow}
            onClick={() => {
              navigate("finance/disputes");
            }}
          >
            Просмотреть все
          </Button>
        </div>
        <Table
          onRowClick={setSelectedAppeal}
          data={appeals}
          loading={state.loading}
          config={traderAppelConfig}
        />
      </Block>
      <RequestModal appeal={selectedAppeal} onClose={hideModal} />
    </>
  );
};
